import { FC } from 'react';
import { Skeleton, SkeletonProps } from '@mui/material';

const sx = {
	borderRadius: '80px',
	background: 'linear-gradient(90deg, #F3F3F3 0%, #EAEAEA 100%)',
};

type TSkeletonProps = Pick<SkeletonProps, 'variant' | 'width' | 'height'>;

export const MplTabLabelSkeleton: FC<TSkeletonProps> = ({
	variant = 'circular',
	width = 40,
	height = 18,
}) => (
	<Skeleton
		variant={variant}
		width={width}
		height={height}
		animation="pulse"
		sx={sx}
	/>
);
